import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { getDateLocale } from '@app/utils/date-locale'

// i8n blog date
export const BlogDate = ({ date }: { date: Date }) => {
  const router = useRouter()
  const [timeStamp, setTime] = useState<string>('')

  // TODO: use lang
  const lang = router.locale

  useEffect(() => {
    // SSR DATE needs to match TZ
    if (date) {
      setTime(
        getDateLocale(date, lang, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      )
    }
  }, [lang, date, setTime])

  const dt = date.toISOString()

  return (
    <time className='text-sm text-black dark:text-gray-200' dateTime={dt}>
      {timeStamp ? (
        timeStamp
      ) : (
        <div className='w-24 min-h-[1.0625rem] bg-gray-300 dark:bg-gray-700'>
          <div className='sr-only'>{dt}</div>
        </div>
      )}
    </time>
  )
}
